export function initChristmasMarketOfferAccess(root = document) {
  const form = root.querySelector('[data-christmas-market-offer-access]')
  if (!form) return

  const tokenInput = form.querySelector('[name="token"]')
  const contextInput = form.querySelector('[name="offer_context"]')
  const status = root.querySelector('[data-christmas-market-offer-access-status]')
  const encodedToken = window.location.hash.slice(1)
  if (!encodedToken || !tokenInput || !contextInput) {
    if (status) status.textContent = form.dataset.missingTokenMessage || ''
    return
  }

  let token
  try {
    token = decodeURIComponent(encodedToken)
  } catch (_error) {
    if (status) status.textContent = form.dataset.missingTokenMessage || ''
    return
  }
  if (!/^[0-9a-f]{64}$/.test(token)) {
    if (status) status.textContent = form.dataset.missingTokenMessage || ''
    return
  }

  tokenInput.value = token
  if (status) status.textContent = form.dataset.openingMessage || ''
  window.history.replaceState(null, '', window.location.pathname)
  form.requestSubmit()
}
